import React, { useState, useContext } from "react";
import { TextField, Divider, Container, Button } from "@mui/material";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { isEmpty } from "lodash";
import { Stack } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { addPeriodicidadAsync } from "../../../api/Periodicidad";

const AddPeriodicidad = ({ setShowModal }) => {
  const token = getToken();
  const { reload, setReload, setIsLoading, setIsLogged, setIsUnautorized } =
    useContext(DataContext);
  const [description, setDescription] = useState("");
  const [cantidadDias, setCantidadDias] = useState("");
  const [cuotaDias, setCuotaDias] = useState("");

  const saveChangesAsync = async () => {
    if (validate()) {
      const data = {
        description,
        cantidadDias,
        cuotaDias,
      };

      setIsLoading(true);
      const result = await addPeriodicidadAsync(token, data);
      if (!result.statusResponse) {
        setIsLoading(false);

        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }

        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      simpleMessage("Periodicidad Agregada...!", "success");
      setReload(!reload);
      setShowModal(false);
    }
  };

  //Devuelve un entero positivo
  const funtionSetCantidadDias = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setCantidadDias(value);
      return;
    }
  };

  //Devuelve un entero positivo
  const funtionSetCuotaDias = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setCuotaDias(value);
      return;
    }
  };

  //Validando campos ingresados
  const validate = () => {
    let isValid = true;
    if (isEmpty(description)) {
      simpleMessage("Debe ingresar una descripcion", "error");
      return (isValid = false);
    }

    if (isEmpty(cantidadDias)) {
      simpleMessage("Debe ingresar una cantidad de días", "error");
      return (isValid = false);
    }

    if (isEmpty(cuotaDias)) {
      simpleMessage("Debe ingresar cada cuantos días se cobra", "error");
      return (isValid = false);
    }

    if (cantidadDias === 0 || cuotaDias === 0) {
      simpleMessage("Debe ingresar una cantidad mayor que cero", "error");
      return (isValid = false);
    }
    return isValid;
  };

  return (
    <div>
      <Divider />

      <Container style={{ width: 450 }}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            required
            onChange={(e) => setDescription(e.target.value.toUpperCase())}
            value={description}
            label={"Descripcion Periocidad"}
          />
          <TextField
            fullWidth
            required
            onChange={(e) => funtionSetCantidadDias(e.target.value)}
            value={cantidadDias}
            label={"Cantidad de días"}
          />
          <TextField
            fullWidth
            required
            onChange={(e) => funtionSetCuotaDias(e.target.value)}
            value={cuotaDias}
            label={"Cuota días"}
          />

          <Button
            variant="outlined"
            startIcon={
              <FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
            }
            fullWidth
            onClick={() => saveChangesAsync()}
            style={{
              color: "#4caf50",
              borderColor: "#4caf50",
            }}
            size="large"
          >
            Agregar Periocidad
          </Button>
        </Stack>
      </Container>
    </div>
  );
};

export default AddPeriodicidad;
